import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

//import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import logo from './logo.png';
const Register = () => {
	
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [nom, setNom] = useState('');
  const [civilite, setCivilite] = useState('');
  const [postnom, setPostnom] = useState('');
  const [prenom, setPrenom] = useState('');
  const [telephone, setTelephone] = useState('');
  const [adresseRes, setAdresseRes] = useState('');
  const [adresseLiv, setAdresseLiv] = useState('');
  const [diffAdresse, setDiffAdresse] = useState(false);
  const [dateNaissance, setDateNaissance] = useState('');
  const [paysList, setPaysList] = useState([]);
  const [pays, setPays] = useState('');
  const [paysLiv, setPaysLiv] = useState('');
  const [step, setStep] = useState(1);
	const [messageType, setMessageType] = useState(''); // 'success', 'danger', etc.
	const [confirmPassword, setConfirmPassword] = useState('');
	const [acceptCGU, setAcceptCGU] = useState(false);



  const navigate = useNavigate();
  
	useEffect(() => {
	  fetch('https://ekapi.bblconcept.com/getData.php?action=getPays') 
		.then(res => res.json())
		.then(data => setPaysList(data))
		.catch(console.error);
	}, []);
	
	const verifierMotDePasse = (password) => {
	  const regex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).{8,}$/;
	  return regex.test(password);
	};
		const verifierExistenceMail = async () => {
			  try {
				const response = await fetch('https://ekapi.bblconcept.com/getData.php?page=Register&action=checkUser', {
				  method: 'POST',
				  headers: { 'Content-Type': 'application/json' },
				  body: JSON.stringify({ email, telephone })
				});
				const data = await response.json(); // <-- ici on récupère le JSON

				if (data.existsEmail) {
				  setMessage('Cet email est déjà enregistré.');
				  setMessageType('danger');
				  return false;
				}
				return true;

			  } catch (err) {
				console.error(err);
				setMessage('Impossible de vérifier l\'email pour le moment.');
				setMessageType('danger');
				return false;
			  }

		};
		const verifierExistenceTel = async () => {
		 try {
				const response = await fetch('https://ekapi.bblconcept.com/getData.php?page=Register&action=checkUser', {
				  method: 'POST',
				  headers: { 'Content-Type': 'application/json' },
				  body: JSON.stringify({ email, telephone })
				});

				if (!response.ok) {
				  throw new Error(`Erreur réseau: ${response.status}`);
				}

				const data = await response.json(); // <-- ici on récupère le JSON

				if (data.existsTel) {
				  setMessage('Ce numéro de téléphone est déjà enregistré.');
				  setMessageType('danger');
				  return false;
				}

				return true;

			  } catch (err) {
				console.error(err);
				setMessage('Impossible de vérifier l\'email pour le moment.');
				setMessageType('danger');
				return false;
			  }
		};
		
		const verifierAge = (dateNaissance) => {
		  const today = new Date();
		  const birthDate = new Date(dateNaissance);

		  let age = today.getFullYear() - birthDate.getFullYear();
		  const monthDiff = today.getMonth() - birthDate.getMonth();

		  // Si le mois ou le jour n’est pas encore atteint cette année, réduire l’âge
		  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
			age--;
		  }

		  return age >= 18;
		};

	
	const validerEtPasser = async () => {
		  if (!email || !password) {
			setMessage('Veuillez remplir tous les champs obligatoires.');
			setMessageType('danger');
			return;
		  } 

		  if (!verifierMotDePasse(password)) {
			setMessage('Le mot de passe doit être valide. Au moins une majuscule, un caratère spécial et un chiffre');
			setMessageType('danger');
			return;
		  }

		  if (password !== confirmPassword) {
			setMessage('Les mots de passe ne correspondent pas.');
			setMessageType('danger');
			return; 
		  }

		  // vérifier l'existence
		  const exists = await verifierExistenceMail();
		  if (!exists) return; // empêcher de passer à l'étape 2 si existe
			
			

		  // Si tout est bon, passe à l'étape 2
		  setMessage('');
		  setStep(2);
};

const validerEtPasser2 = async () => {
		if (!nom || !prenom || !dateNaissance || !telephone) {
			setMessage('Veuillez remplir tous les champs obligatoires.');
			setMessageType('danger');
			return;
		  } 
		  // vérifier l'existence
		  const exists = await verifierExistenceMail();
		  if (!exists) return; // empêcher de passer à l'étape 2 si existe
			
		  
			if (!verifierAge(dateNaissance)) {
				setMessage('Vous devez avoir plus de 18 ans pour vous inscrire.');
				setMessageType('danger');
				return;
			  }

		  // Si tout est bon, passe à l'étape 2
		  setMessage('');
		  setStep(3);
};

  const handleSubmit = async (e) => {
    e.preventDefault();
	if (!acceptCGU) {
		  setMessage('Vous devez accepter les CGU et RGPD pour continuer.');
		  setMessageType('danger');
		return;
	}
    try {
		
		const res = await fetch('https://ekapi.bblconcept.com/register.php',{
        method:'POST',
        headers:{ 'Content-Type':'application/json' },
        body: JSON.stringify({
        email,
        password,
		telephone,
		civilite,
		nom,
		postnom,
		prenom,
		dateNaissance,
		adresseRes,
		adresseLiv,
		pays,
		paysLiv,
        })
      });
	  
	  const data = await res.json();  // <-- obligatoire
	   if (!res.ok) {
		throw new Error(data.message || "Erreur serveur");
	  }
	
      setMessage(data.message);
      setEmail('');
      setPassword('');
	  
	  // Après succès, rediriger vers la page confirmation
      navigate('/confirmation', { state: { email } });
    } catch (error) {
      setMessage(error.response || "Erreur lors de l'inscription. Veuillez recommencer, si le problème persite, contactez le support.");
    }
  };

  return (
    <div className="login-container  d-flex justify-content-center align-items-center min-vh-100 mt-1"  style={{ backgroundColor: '#03224C' }}>
		
	   <div className="card p-4 shadow col-md-8 col-lg-6" style={{ flex: '1', backgroundColor: '#00fAR5'}}>  
	  <div className="text-center">
           <img src="logo2.jpg" className="logoConnexion" alt="Logo"/>
			<p className="mb-4 text-secondary" style={{ fontSize: '14px' }}>Ici une description</p>
			
		{/* <img src={logo} alt="Logo" style={{ maxWidth: '200px'}} className="mb-4" />*/}
       </div>
        <h2 className="text-center mb-4">Inscription</h2>
		{message && (
      <div className={`alert text-center alert-${messageType}`} role="alert">
        {message}
      </div>
    )}

        <form onSubmit={handleSubmit}>
		{step === 1 && (
       <>
          <div className="mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div> 
			
          <div className="mb-3">
            <label className="form-label">Mot de passe</label>
            <input
              type="password"
              className="form-control"
              placeholder="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
			<small className="form-text text-info">
				Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule, et un chiffre.
			  </small>
          </div>
		  <div className="mb-3">
		  <label className="form-label">Confirmer le mot de passe</label>
		  <input
			type="password"
			className="form-control"
			placeholder="Confirmer le mot de passe"
			value={confirmPassword}
			onChange={(e) => setConfirmPassword(e.target.value)}
		  />
		  {password !== confirmPassword && (
				  <small className="text-danger">Les mots de passe ne correspondent pas.</small>
				)}

		</div>
		<button type="button" className="btn btn-primary mb-3" onClick={validerEtPasser}>
        Suivant
		</button>
			  </>
	)}
	{step === 2 && (
	<>
	<div className="mb-3">
		  <label className="form-label">Civilité</label>
			<select
			  className="form-select"
			  value={civilite}
			  onChange={(e) => setCivilite(e.target.value)}
			  required
			>
			  <option value="">Vous êtes</option>
	
				<option key="1" value='Mademoiselle'>Mademoiselle</option>
				<option key="2" value='Madame'>Madame</option>
				<option key="3" value='Monsieur'>Monsieur</option>
			
			</select>
		</div>
      <div className="mb-3">
        <label className="form-label">Nom</label>
        <input
          type="text"
          className="form-control"
          placeholder="Nom"
          value={nom}
          onChange={(e) => setNom(e.target.value)}
          required
        />
      </div>

     
      <div className="mb-3">
        <label className="form-label">Postnom</label>
        <input
          type="text"
          className="form-control"
          placeholder="Postnom"
          value={postnom}
          onChange={(e) => setPostnom(e.target.value)}
        />
      </div>

   
      <div className="mb-3">
        <label className="form-label">Prénom</label>
        <input
          type="text"
          className="form-control"
          placeholder="Prénom"
          value={prenom}
          onChange={(e) => setPrenom(e.target.value)}
          required
        />
      </div>
	   
      <div className="mb-3">
        <label className="form-label">Date de naissance</label>
        <input
          type="date"
          className="form-control"
          value={dateNaissance}
          onChange={(e) => setDateNaissance(e.target.value)}
          required
        />
      </div>

     
      <div className="mb-3">
        <label className="form-label">Téléphone</label>
        <input
          type="tel"
          className="form-control"
          placeholder="Téléphone"
          value={telephone}
          onChange={(e) => setTelephone(e.target.value)}
          required
        />
      </div>
	   <div className="d-flex justify-content-between mt-3">
	   <button type="button" className="btn btn-secondary mb-3" onClick={() => setStep(1)}>Précédent</button>
         
	   <button type="button" className="btn btn-primary mb-3" onClick={validerEtPasser2}>
        Suivant
      </button>
	  </div>
	  </>
	)}
	{step === 3 && (
	<>
      {/* Adresse de résidence */}
      <div className="mb-3">
        <label className="form-label">Adresse de résidence</label>
        <input
          type="text"
          className="form-control"
          placeholder="Adresse de résidence"
          value={adresseRes}
          onChange={(e) => setAdresseRes(e.target.value)}
          required
        />
      </div>
	  {/* Pays */}
		<div className="mb-3">
		  <label className="form-label">Pays</label>
			<select
			  className="form-select"
			  value={pays}
			  onChange={(e) => setPays(e.target.value)}
			  required
			>
			  <option value="">Sélectionnez votre pays</option>
			  {paysList.map((p) => (
				<option key={p.id} value={p.name}>{p.name}</option>
			  ))}
			</select>
		</div>

      {/* Checkbox pour adresse de livraison différente */}
      <div className="mb-3 form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="diff Adresse"
          checked={diffAdresse}
          onChange={(e) => setDiffAdresse(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="diff Adresse">
          Adresse de livraison différente
        </label>
      </div>

      {/* Adresse de livraison (si différente) */}
      {diffAdresse && (
        <div className="mb-3">
          <label className="form-label">Adresse de livraison</label>
          <input
            type="text"
            className="form-control"
            placeholder="Adresse de livraison"
            value={adresseLiv}
            onChange={(e) => setAdresseLiv(e.target.value)}
            required
          />
		 <label className="form-label">Pays livraison</label>
			<select
			  className="form-select"
			  value={paysLiv}
			  onChange={(e) => setPaysLiv(e.target.value)}
			  required
			>
			  <option value="">Sélectionnez votre pays</option>
			  {paysList.map((p) => (
				<option key={p.id} value={p.name}>{p.name}</option>
			  ))}
			</select>
        </div>
		
      )}
			<div className="form-check mb-3">
			  <input
				className="form-check-input"
				type="checkbox"
				id="acceptCGU"
				checked={acceptCGU}
				onChange={(e) => setAcceptCGU(e.target.checked)}
			  />
			  <label className="form-check-label" htmlFor="acceptCGU">
				J’accepte <Link to="/cgu">les Conditions Générales d’Utilisation (CGU) et la Politique RGPD</Link>
			  </label>
			</div>

          {/* Bouton */}
		   <div className="d-flex justify-content-between mt-3">
			<button type="button" className="btn btn-secondary" onClick={() => setStep(2)}>Précédent</button>
			<button className="btn btn-primary" type="submit">
            S'inscrire
			</button>
		  </div>
		  </>
		  )}
        </form>
		
		
        {/* Message */}
        {message && (
			 <div className="mt-3">
            <p className="alert alert-danger text-center">{message}</p>
			</div>
        )}
		 <div className="d-flex justify-content-between mt-3">
			  <Link to="/login" className="text-decoration-none">Se connecter</Link>
			  
		 </div>
		
      </div>
	  
		<div className="login-bottom"></div>
		   <p className="text-center text-white" style={{ fontSize: '12px' }}>
		  © {new Date().getFullYear()} Empreinte Kapital - by BLConcept
			</p>
		</div>

	
  );
};

export default Register;
